import Const from '@/helpers/const'
import { custAxios } from './genericApi'

export default {
  getContractModels () {
    return custAxios().get(`${Const.API_MODELS}`)
  }
}
